import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { finalize, map } from 'rxjs/operators';
import { Loading, LoadingService } from '@core/service/loading.service';

/**
 * Prefixes all requests with `environment.serverUrl`.
 */
@Injectable()
export class ApiPrefixInterceptor implements HttpInterceptor {
  constructor(private loader: LoadingService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.loader.UpdateLoader({ status: 'success', isLoader: true });
    console.log('Recuest', request);
    /**
     * si es paginado quitamos la url
     */
    if (request.headers.get('paginate')) {
      request = request.clone({ url: '' });
    } else {
      request = request.clone({ url: environment.serverBaseUrl + request.url });
    }

    if (
      JSON.parse(localStorage.getItem('credentials')) &&
      JSON.parse(localStorage.getItem('credentials')).user.sucursal_id != null
    ) {
      request = request.clone({
        setHeaders: {
          ID: JSON.parse(localStorage.getItem('credentials')).user.sucursal_id
        }
      });
    }

    // console.log('interceptor Core: ', request);
    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          // console.log('event--->>>', event);
          if (event.statusText !== 'OK') {
            this.loader.UpdateLoader({ status: 'danger', isLoader: true });
          }
        }
        return event;
      }),
      finalize(() => {
        // console.log(request);
        this.loader.UpdateLoader({ status: 'success', isLoader: false });
      })
    );
  }
}
